class OverlayImage {
    constructor() {
        this.displayPopupBtn = document.querySelectorAll('.modal-popup-ce');
        this.overlay         = document.getElementById('overlay-popup');
        this.closePopupBtn   = document.getElementById('close-popup');

        this.showPopup();
        this.closePopup();
    }

    showPopup() {
        for (let i = 0; i < this.displayPopupBtn.length; i++) {
            this.displayPopupBtn[i].addEventListener('click', () => {
                this.overlay.classList.add('active');
            });
        }
    }

    closePopup() {
        this.closePopupBtn.addEventListener('click', () => {
            this.overlay.classList.remove('active');
        });
    }
}